
import React from 'react';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Row, Col, Space, Button } from 'antd';
import cover from '../../../assets/icons/image/01.svg';

export default function Header(props) {
    return (
        <Row wrap={true} className='mb-15'>
            <Col flex="auto">
                <div className='vertical-center'>
                    <Space wrap>
                        <img src={cover} height={24} alt="img" className='align-middle' />
                        <span className='title-page'>Portadas</span>
                    </Space>
                </div>
            </Col>
            <Col flex="none">
                <Space wrap>
                    <Button
                        shape="round"
                        icon={<SearchOutlined />}
                        onClick={props.onLoad}
                    >
                        Buscar
                    </Button>
                    <Button
                        type='primary'
                        shape='round'
                        icon={<PlusOutlined />}
                        onClick={props.onNew}
                    >
                        Nuevo
                    </Button>
                </Space>
            </Col>
        </Row>
    )
}